'use client';

import React from 'react';
import type { SearchPageData } from '@/app/search/createSearchPageData';

// The view mode the payload carries is turned into client state by the results page itself, in
// useViewMode: this provider outlives the destinations/results switch, that state must not. (MPH-931)
export type SearchPageDataContextValue = SearchPageData;

export const SearchPageDataContext = React.createContext<SearchPageDataContextValue>({} as SearchPageDataContextValue);

export default function SearchPageDataProvider({
  searchPageData,
  children,
}: {
  searchPageData: SearchPageData;
  children: React.ReactNode;
}) {
  return <SearchPageDataContext.Provider value={searchPageData}>{children}</SearchPageDataContext.Provider>;
}

export const useSearchPageData = () => React.useContext(SearchPageDataContext);
